import apiService from '../../../services/api-client';
import { DeleteWarehouseResponse } from '../interfaces/delete-warehouse';
import { GetWarehousesResponse } from '../interfaces/get-warehouses';
import { PostWarehousePayloadRequest, PostWarehouseResponse } from '../interfaces/post-warehouse';
import { PutWarehousePayloadRequest, PutWarehouseResponse } from '../interfaces/put-warehouse';

export const matersApiService = {
  async getWarehouses(id: number, filters?: {
    code?: string;
    description?: string;
    channel_type_id?: string;
  }) {
    const params = new URLSearchParams();
    if (filters?.code) params.append('code', filters.code);
    if (filters?.description) params.append('description', filters.description);
    if (filters?.channel_type_id) params.append('channel_type_id', filters.channel_type_id);
    
    const { data } = await apiService().get<GetWarehousesResponse>(`company/${id}/warehouses`, {
      params: Object.fromEntries(params)
    });
    return data;
  },
  async postWarehouse(id: number, body: PostWarehousePayloadRequest) {
    const { data } = await apiService().post<PostWarehouseResponse>(`company/${id}/warehouse`, body);
    return data;
  },
  async putWarehouse(cId: number, tId: number, body: PutWarehousePayloadRequest) {
    const { data } = await apiService().put<PutWarehouseResponse>(
      `company/${cId}/warehouse/${tId}`,
      body
    );
    return data;
  },
  async deleteWarehouse(cId: number, tId: number) {
    const { data } = await apiService().delete<DeleteWarehouseResponse>(
      `company/${cId}/warehouse/${tId}`
    );
    return data;
  },
};
